
import { Button } from 'antd';
import { ButtonProps } from 'antd/lib/button';

import { isEmpty } from 'lodash';
import { ILoginState } from '@share/store/slices';

import { useSelector } from 'react-redux';
import { RootState } from '@share/utils';

import './style.scss';

interface IProps extends ButtonProps {}

export function WhiteButton(props: IProps) {

  const loginStore: ILoginState = useSelector((state: RootState) => state.loginStore);

  const account = loginStore?.account;
  const buttonBorderRadius: any = account?.buttonBorderRadius ? account?.buttonBorderRadius : null;
  const styleButton = !isEmpty(buttonBorderRadius) ? { borderRadius: `${buttonBorderRadius}px` } : {};  

  return (
    <Button {...props} className={`white-button ${props.className ? props.className : ''}`} style={styleButton}>
      {props.children}
    </Button>
  );
}
